import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { CarriersSelectCellBase } from './CarriersSelectCell'

import { carriersSelector } from 'reduxModules/selectors/GlobalSelectors'

const mapStateToProps = createStructuredSelector({
  carriers: carriersSelector,
})

export const CarriersSelectCell = connect(mapStateToProps)(CarriersSelectCellBase)



// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/CarriersSelectCell/index.js